<template>
  <div id="app">
    <NavTopBar v-bind:bezieAppObj="this.bezieAppObj"/>
    <ContentArea v-bind:bezieAppObj="this.bezieAppObj"/>
  </div>
</template>

<script>
import NavTopBar from './components/NavTopBar.vue'
import ContentArea from './components/ContentArea.vue'
import { BezieApp } from './lib/bezieLib/BezieApp';
import { main, bezieApp } from './lib/bezieLib/main';
import GifJS from './lib/external/gif/gif';

export default {
  name: 'app',
  components: {
    NavTopBar,
    ContentArea
  },
  data: function(){
    return{
      bezieAppObj : null
    }
  },
  mounted: function(){
    main()
    if(bezieApp){
      this.bezieAppObj = bezieApp
      console.log('bezieapp is initialized')
    } else {
      console.log('should ABORT!!!')
      this.$Notify({
          title: 'Initialization error',
          message: 'Kindly close and reload app',
          type: 'error'
        })
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  overflow: hidden;
  height: 100%;
}

span{
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
}

body{
  height: 100%;
}

.brandColor {
  background-color: #f18138 !important;
}

.borderColor {
  border-color: white !important;
}

.darkColor {
  background-color: #505050 !important;
}

/*
 *  STYLE 1
 */

.use-bscroll::-webkit-scrollbar-track
{
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
	border-radius: 8px;
	background-color: #F5F5F5;
  z-index: 2;
}

.use-bscroll::-webkit-scrollbar
{
	width: 6px;
  height: 6px;
	background-color: #F5F5F5;
  z-index: 2;
}

.use-bscroll::-webkit-scrollbar-thumb
{
	border-radius: 8px;
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
	background-color: #979797;
  z-index: 2;
}
</style>
